import React,{Component} from "react";

import {Footer} from '../footer/Footer';
import {Header} from '../header/Header';
export class ControllerHistory extends Component{
    render(){
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <br/>
            <div className="container">
                <div className="text-center">
                    <h3>HISTORY OF CONTROLLERS</h3>
                </div>
                <ul>
                    <li>
                        <p><b>Syed Shukat Hasan  </b></p>
                        <p>FROM: 4-Jan-1974 TO: 28-May-1975</p>
                    </li>
                    <li>
                    <p><b>Mr. Iqbal Ahmed Siddiqui </b></p>
                        <p>FROM: 29-May-1975 TO: 18-Feb-1975</p>
                    </li>
                    <li>
                    <p><b>Mr. Ghulam Sarwar Thahim </b></p>
                        <p>FROM: 18-Feb-1975 TO: 10-Jan-1977</p>
                    </li>
                    <li>
                    <p><b>Syed Shukat Hasan </b></p>
                        <p>FROM: 10-Jan-1977 TO: 2-Oct-1992</p>
                    </li>
                    <li>
                    <p><b>Prof Qazi Ahmed Sayeed </b></p>
                        <p>FROM: 2-Oct-1992 TO: 14-Apr-1992</p>
                    </li>
                    <li>
                    <p><b>Mr. Iqbal Ahmed Siddiqui </b></p>
                        <p>FROM: 14-Apr-1992 TO: 28-Jun-1992</p>
                    </li>
                    <li>
                    <p><b>Mr. fahim Ahmed </b></p>
                        <p>FROM: 28-Jun-1992 TO: 30-Sep-1992</p>
                    </li>
                    <li>
                    <p><b>Syed Shukat Hasan </b></p>
                        <p>FROM: 30-Sep-1992 TO: 13-Nov-1996</p>
                    </li>
                    <li>
                    <p><b>Prof A Zaheer Khan Paras </b></p>
                        <p>FROM: 13-Nov-1996 TO: 24-Dec-1996</p>
                    </li>
                    <li>
                    <p><b>Syed Shukat Hasan </b></p>
                        <p>FROM: 24-Dec-1996 TO: 6-Nov-1997</p>
                    </li>
                    <li>
                    <p><b>Farooq Kemal Sidiqui </b></p>
                        <p>FROM: 6-Nov-1997 TO: 1-Jun-1996</p>
                    </li>
                    
                    <li>
                    <p><b>Prof karamatullah Rajput </b></p>
                        <p>FROM: 1-Jun-1996 TO: 30-Sep-1998</p>
                    </li>
                    <li>
                    <p><b>Prof Naeem Ullah Siddiqui </b></p>
                        <p>FROM: 12-Sep-1991 TO: 25-Nov-1991</p>
                    </li>
                    <li>
                    <p><b>Mr. Farooq Kemal Siddiqui </b></p>
                        <p>FROM: 1-Oct-1998 TO: 27-Sep-2003</p>
                    </li>
                    <li>
                    <p><b>Prof Naeem Ullah Siddiqui </b></p>
                        <p>FROM: 28-Jun-1992 TO: 2-Feb-1994</p>
                    </li>
                    <li>
                    <p><b>Prof Asif Pasha Siddiqui </b></p>
                        <p>FROM: 27-Sep-2003 TO: 27-Aug-2004</p>
                    </li>
                    <li>
                    <p><b>Prof M. Amin Khalid</b></p>
                        <p>FROM: 27-Aug-2004 TO: 17-Dec-2005</p>
                    </li>
                    <li>
                    <p><b>Prof. Dr. Syed Abdul Aziz </b></p>
                        <p>FROM: 17-Dec-2005 TO: 16th-Jun-2007</p>
                    </li>
                    <li>
                    <p><b>Prof Agha Akbar </b></p>
                        <p>FROM: 19th Jun 2007 TO: 20 April 2011</p>
                    </li>
                    <li>
                    <p><b>Mr. Muhammad Imran Khan Chishti </b></p>
                        <p>FROM: 21 April 2011 TO: 21 Dec 2015</p>
                    </li>
                    <li>
                    <p><b>Muhammad Dabeer (Acting) </b></p>
                        <p>FROM: 22 Dec 2015 TO: 14 Mar 2016</p>
                    </li>
                    <li>
                    <p><b>Mrs. Zarina Rashid (Acting) </b></p>
                        <p>FROM: 14 Mar 2016 TO: 03 Aug 2016</p>
                    </li>
                    <li>
                    <p><b>Mr. Muhammad Imran Khan Chishti  </b></p>
                        <p>FROM: 04 Aug 2016 TO: 09 Mar 2017</p>
                    </li>
                    <li>
                    <p><b>Mr. Muhammad Jaffar (Acting CE)</b></p>
                        <p>FROM: 10 Mar 2017 TO: 24-07-2018</p>
                    </li>
                    <li>
                    <p><b>Mr. Azeem Ahmed (Acting CE)</b></p>
                        <p>FROM: 08-08-2018 TO: To-Date</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}